var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.show)?_c('ResumeProcessQuotation',{attrs:{"form":_vm.currentQuotationToEdit},on:{"return":_vm.previousPage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }